import { reportError } from '@ms/yammer-telemetry';
import type { AuthenticatorOptions } from '@ms/yammer-web-authenticators';
import { AcquireTokenAuthError, AcquireTokenPopupError } from '@ms/yammer-web-authenticators';

export const reportAuthError: AuthenticatorOptions['onError'] = async (error, { authenticatorType, scopes }) => {
  const eventProperties = {
    authenticatorType,
    skipAuthentication: true,
    ...(scopes ? { scopes: scopes.join(',') } : null),
  };

  if (error instanceof AcquireTokenAuthError) {
    await reportError({
      error,
      eventProperties: {
        ...eventProperties,
        errorCode: 'AuthAcquireTokenSilentFailed',
      },
    });
  }

  if (error instanceof AcquireTokenPopupError) {
    await reportError({
      error,
      eventProperties: {
        ...eventProperties,
        errorCode: 'AuthAcquireTokenPopupFailed',
      },
    });
  }
};
